module.exports = __webpack_public_path__ + "img/ZWF_Michal_Dorota.36a5dbf5.jpg";